import React, { useContext, useEffect, useState } from 'react'
import { CButton, CCard, CCardBody } from '@coreui/react';
import { useNavigate } from 'react-router-dom';
import { CHeader } from '@coreui/react';
import { getAllMerchants,  } from 'src/services/Merchants/Merchants';
import { DataGrid } from '@mui/x-data-grid';
import { AuthContext } from 'src/App';
import Authentication, { AUTH_KEY } from 'src/utils/auth/Authentication';

function Merchants() {
  const navigate = useNavigate();
  const Auth = useContext(AuthContext)

  const [merchantList, setMerchantList] = useState([]);
  const [renderCounter, setRenderCounter] = useState(0);
  const [loading, setLoading] = useState(true);
  const [merchantRows, setMerchantRows] = useState([]);

  const merchantColumns = [
    { field: 'merchantName', headerName: 'Merchant Name', width: '100' },
    { field: 'merchantAddress', headerName: 'Merchant Address', width: '100' },
    { field: 'cityID', headerName: 'City ID', width: '100' },
    { field: 'countryID', headerName: 'Country ID', width: '100' },
    { field: 'provinceID', headerName: 'Province ID', width: '100' },
    { field: 'subdistrictID', headerName: 'Subdistrict ID', width: '100' },
    { field: 'zip', headerName: 'ZIP', width: '100' },
    { field: 'picName', headerName: 'PIC Name', width: '100' },
    { field: 'picPhone', headerName: 'PIC Phone', width: '100' },
    { field: 'id', headerName: 'Merchant ID', width: '100' }
  ];

  async function fetchMerchants() {
    const data = await getAllMerchants();

    const mappedData =
      data.data &&
      data.data.map((item, i) => {
        return {
          merchantName: item.name,
          merchantAddress: item.address,
          cityID: item.city_id,
          countryID: item.country_id,
          provinceID: item.province_id,
          subdistrictID: item.subdistrict_id,
          zip: item.zip,
          picName: item.pic_name,
          picPhone: item.pic_phone,
          id: item.id
        };
      });

    setMerchantRows(mappedData);
    setMerchantList(data.data);
  }

  useEffect(() => {
    if (renderCounter === 0) {
      if (JSON.parse(localStorage.getItem('userDetail')).org_id !== 0) {
        navigate('/not-authorized');
      } else {
        fetchMerchants();
      }
    }

    setRenderCounter(renderCounter + 1);
  }, [loading]);

  function handleRowClick(params) {
    const dataFromResponse = merchantList
      .filter((item) => {
        return item.id === params.row.id;
      })
      .map((data) => {
        return {
          latitude: data.latitude,
          longitude: data.longitude
        };
      })[0];

    navigate('/merchant-actions', {
      state: { ...params.row, ...dataFromResponse }
    });
  }

  return (
    <>
      <CCard>
        { Auth.isAllowed(Auth.role[AUTH_KEY.merchant_actions]) &&
            <CButton
                onClick={() => navigate('/merchant-actions')}
                style={{ backgroundColor: '#4E5B97', border: 'none', width: '15vw' }}
                >
                Add Merchants
            </CButton>
        }
        <CCardBody>
          {merchantRows.length > 0 ? (
            <DataGrid
              rows={merchantRows}
              columns={merchantColumns}
              onRowClick={handleRowClick}
              initialState={{
                pagination: {
                  paginationModel: { page: 0, pageSize: 10 }
                }
              }}
              pageSizeOptions={[5, 10, 20, 25]}
              style={{ textAlign: 'center' }}
            />
          ) : (
            <CHeader style={{ color: 'silver', marginBottom: '2vh' }}>
              <p style={{ padding: '0vh 0vw 0vh 2vw' }}>Data Tidak Ditemukan</p>
            </CHeader>
          )}
        </CCardBody>
      </CCard>
    </>
  );
}

export default Merchants;
